import axios from "axios";
import { getObjectFromArray } from "../../../utils/helpers";
import { API_BASE_URL } from "../../../utils/constants";
import { UPDATE_CREDENTIALS, UPDATE_CONTACT_DATA, UPDATE_NOTIFICATIONS, UPDATE_SOCKET_NOTIFICATION, UPDATE_SOCKET_TOKEN, UPDATE_USER_DATA } from "../actionTypes";
import { errorManagementHandler, updateLoading } from "./theme";

export const updateCredentials = (code, email) => {
    localStorage.setItem("code", code);
    localStorage.setItem("email", email);
    return {
        type: UPDATE_CREDENTIALS,
        code,
        email,
    };
};

export const updateContactData = (contactData) => {
    return {
        type: UPDATE_CONTACT_DATA,
        contactData,
    };
};

export const verifyEmail = (code, email, callback) => {
    return (dispatch, getState) => {
        dispatch(updateLoading(true));

        const { language } = getState().theme;
        axios
            .post(
                `${API_BASE_URL}/external/auth/verify/`,
                {},
                {
                    headers: {
                        "Accept-Language": language || "es",
                        "Verification-Code": code,
                        "External-User-Email": email,
                    },
                }
            )
            .then((res) => {
                dispatch(updateCredentials(code, email));
                dispatch(updateContactData(res.data));
                dispatch(updateLoading(false));
                if (callback) callback();
            })
            .catch((e) => {
                if (!callback && e.response?.status === 585) {
                    dispatch(logout());
                }
                dispatch(errorManagementHandler(e));
            });
    };
};

export const logout = () => {
    return () => {
        localStorage.removeItem("code");
        localStorage.removeItem("email");

        window.open(`/login?next=${window.location.pathname}`, "_parent");
    };
};

export const fetchSocketToken = (email, code) => {
    return (dispatch) => {
        const language = localStorage.getItem("i18nextLng") ? localStorage.getItem("i18nextLng") : "en";

        axios
            .get(`${API_BASE_URL}/external/websocket/token/`, {
                headers: {
                    "Verification-Code": code,
                    "External-User-Email": email,
                    "Accept-Language": language,
                },
            })
            .then((res) => dispatch(updateSocketToken(res.data.token)))
            .catch((e) => {
                if (e.response?.status === 403) {
                    dispatch(errorManagementHandler(e));
                }
                dispatch(updateLoading(false));
            });
    };
};

export const updateNotifications = (notifications, notificationTotal, notificationUnreadNumber) => {
    return {
        type: UPDATE_NOTIFICATIONS,
        notifications,
        notificationTotal,
        notificationUnreadNumber,
    };
};

export const updateSocketNotification = (socketNotification) => {
    return {
        type: UPDATE_SOCKET_NOTIFICATION,
        socketNotification,
    };
};

export const updateUserData = (userData) => {
    let signatureNumberObject = {};
    if (!!userData && !!userData.signature_number) {
        signatureNumberObject = getObjectFromArray(
            userData.signature_number.filter((i) => i.product),
            (item) => item.product.product_id,
        );
    }
    return {
        type: UPDATE_USER_DATA,
        userData: userData
            ? {
                  ...userData,
                  signature_number_object: signatureNumberObject,
              }
            : null,
    };
};

export const updateSocketToken = (socketToken) => {
    localStorage.setItem("socket_token", socketToken);
    return {
        type: UPDATE_SOCKET_TOKEN,
        socketToken,
    };
};